import CtaLink from './CtaLink';
import Reveal from '@/components/base/Reveal';
import { dfyFeatures, dwyFeatures } from '@/mocks/home';

export default function WaysToWork() {
  return (
    <section id="work-with-josh" className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Two Ways to Work Together
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Choose How You Want to Grow
          </h2>
          <p className="mt-4 text-foreground-600">
            Whether you want the work fully handled for you, or strategic
            guidance for your existing team — there is a path that fits where
            you are today.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* DFY card */}
          <Reveal delay={0}>
            <div className="relative h-full rounded-2xl border border-white/10 bg-gradient-to-b from-background-200 to-background-100 p-8 md:p-10">
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 text-primary-400 px-3 py-1 text-xs font-label font-semibold">
                  <i className="ri-sparkling-2-line"></i>
                  Done For You
                </span>
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-950">
                  <i className="ri-rocket-line text-xl"></i>
                </span>
              </div>
              <h3 className="mt-6 font-heading font-bold text-2xl text-foreground-950">
                Done For You Marketing
              </h3>
              <p className="mt-3 text-foreground-600 leading-relaxed">
                For business owners who want Josh and his team to handle
                strategy, implementation, optimization, and growth systems end
                to end.
              </p>
              <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {dfyFeatures.map((f) => (
                  <li
                    key={f}
                    className="flex items-center gap-2.5 text-sm text-foreground-700">
                    <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                      <i className="ri-checkbox-circle-line"></i>
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="mt-8">
                <CtaLink className="w-full">Apply for DFY Marketing</CtaLink>
              </div>
            </div>
          </Reveal>

          {/* DWY card */}
          <Reveal delay={120}>
            <div className="relative h-full rounded-2xl border border-primary-500/30 bg-background-100 p-8 md:p-10">
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                  <i className="ri-compass-3-line"></i>
                  Done With You
                </span>
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-background-950">
                  <i className="ri-user-star-line text-xl"></i>
                </span>
              </div>
              <h3 className="mt-6 font-heading font-bold text-2xl text-foreground-950">
                Done With You Consulting
              </h3>
              <p className="mt-3 text-foreground-600 leading-relaxed">
                For established teams who already have internal staff,
                marketers, or systems in place and want strategic guidance from
                Josh.
              </p>
              <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {dwyFeatures.map((f) => (
                  <li
                    key={f}
                    className="flex items-center gap-2.5 text-sm text-foreground-700">
                    <span className="w-4 h-4 flex items-center justify-center text-accent-400">
                      <i className="ri-checkbox-circle-line"></i>
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="mt-8">
                <CtaLink className="w-full">Apply for DWY Consulting</CtaLink>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
